import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=0f35d821&lang=scss"

const __exports__ = script;

export default __exports__